import StreamingError, { StreamingErrorCodes } from './StreamingError';
import { StreamingEventBus } from './StreamingEventBus';
import {
  DoryMessageType,
  DoryStreamingMessage,
  StreamingEventHandler,
} from './StreamingMessages';

export type StreamingSubscriptionEventHandler<T extends DoryStreamingMessage> =
  {
    handler: StreamingEventHandler<T> | undefined;
    isAttached: boolean;
    attach: () => void;
    detach?: () => void;
  };

export default abstract class StreamingSubscription<
  SubscribeTo,
  RequestMessage extends DoryStreamingMessage
> {
  protected id: string;
  protected eventBus: StreamingEventBus;
  protected pending: string[] = [];
  public get isPending(): boolean {
    return this.pending.length !== 0;
  }

  public abstract get subscribed(): SubscribeTo;

  public abstract readonly on: {
    [key in DoryMessageType]?: StreamingSubscriptionEventHandler<DoryStreamingMessage>;
  };

  public abstract get SubscribeRequest(): RequestMessage;

  constructor(id: string, eventBus: StreamingEventBus) {
    this.id = id;
    this.eventBus = eventBus;
  }

  public abstract start(timeout: number): void;
  public abstract restart(timeout: number, pending: string[]): void;
  public abstract stop(): void;

  //#region Timeout
  private pendingTimeout: number;
  protected startTimeout(
    timeout: number,
    source: string,
    handler: (msg: DoryStreamingMessage, err: StreamingError) => void
  ): void {
    this.pendingTimeout = window.setTimeout(() => {
      handler(
        undefined,
        new StreamingError(
          source,
          StreamingErrorCodes.TIMEOUT,
          'Request to WebSocket timed out!'
        )
      );
      this.stopTimeout();
    }, timeout);
  }
  protected stopTimeout(): void {
    if (this.pendingTimeout) {
      window.clearTimeout(this.pendingTimeout);
      this.pendingTimeout = undefined;
    }
  }
  //#endregion
}
